import type { BaseController } from '@infra/controllers/base.controller';
import type { HangupCallUsecase } from '@usecases/hangup-call.usecase';

export type HangupCallInput = void;

export type HangupCallOutput = void;

export class HangupCallController
  implements BaseController<HangupCallInput, HangupCallOutput>
{
  constructor(private usecase: HangupCallUsecase) {}

  async handle(): Promise<HangupCallOutput> {
    await this.usecase.run();
  }
}
